import $ from 'jquery'
import "moment/min/locales";
import "xlsx/dist/xlsx.full.min.js";
import Dropzone from "./Dropzone.js";
import Loading from "../ui/Loading.js";
import { Redirect } from "react-router-dom";
import * as Utils from '../../commons/utils/Utils'
import backendStrings from '../../lang/backendStrings.js';
import { FormattedMessage, injectIntl } from "react-intl";
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import Security from '../../commons/security/Security.js'
import { ITEM_TIPO_PRODUCTO, ITEM_TIPO_MANO_DE_OBRA, esManoDeObra } from '../../commons/constants/itemsTipos.js'
import { permisosCargaPorMomento } from '../../commons/constants/presupuestoCarga.js'
import { tieneMezclaValidacionAutomatica } from '../presupuestoDetallado/mezclaValidacionAutomatica.js'
import { pedirCantidadesSolicitud, solicitudesAbiertasPorItem, accionTrasSolicitudStock, CANCELADO, GUARDAR_BORRADOR } from '../inventario/solicitudStockFlow.js'
import React, { useState, useEffect, useLayoutEffect } from "react";
import PresupuestoDetalladoItem from "../presupuestoDetallado/PresupuestoDetalladoItem.js";
import PresupuestoDetalladoTarea from "../presupuestoDetallado/PresupuestoDetalladoTarea.js";
import Swal from 'sweetalert2';
import { formatCost } from '../../commons/utils/Helpers.js';

const FORM_DATA_INIT = {
	id: null,
	manoDeObra: 0,
	repuestos: 0,
	impuestos: 0,
	otros: 0,
	adjunto: null,
	adicional: false,
	presupuestoItems: [],
	presupuestoTareas: []

}

const requiredSymbol = ' *';

const TicketPresupuestoDetallado = (props) => {
  	const intl = props.intl;
	const [loading, setLoading] = useState(false);
  	const [redirectTo, setRedirectTo] = useState(null);
	const [presupuestoItems, setPresupuestoItems] = useState([]);
	/**
	 * VEC-3316 — mapa `{ idItem: disponible }` del stock en la base del móvil del ticket.
	 *
	 * Los ítems del presupuesto NO pasan por ningún select: se arman desde `data.items` en `init()`
	 * y ese objeto nunca tuvo `stockDisponible`. El desplegable sí trae el dato —`simple-search` y
	 * `items-de-servicio` ahora lo devuelven—, pero eso solo sirve mientras se elige un ítem nuevo.
	 *
	 * Por eso el stock de lo YA CARGADO se pide aparte, en UNA sola llamada para todos los ids.
	 * `null` como valor significa "no se puede saber" (mano de obra, o sin base); un id ausente es
	 * un ítem que no existe.
	 */
	const [stockPorItem, setStockPorItem] = useState({});
	const [presupuestoTareas, setPresupuestoTareas] = useState([]);
	const [presupuestoItemsManoDeObra, setPresupuestoItemsManoDeObra] = useState([]);
	const [formData, setFormData] =  useState({ ...FORM_DATA_INIT });
	const [totalRepuestos, setTotalRepuestos] = useState(0);
	const [totalManoObra, setTotalManoObra] = useState(0);
	const [totalManoDeObraItems, setTotalManoDeObraItems] = useState(0);
	const [totalTareas, setTotalTareas] = useState(0);
	const [impuestos, setImpuestos] = useState(0);
	const [otros, setOtros] = useState(0);
	const [total, setTotal] = useState(0);
	const [adjunto, setAdjunto] = useState(null);
	const [errors, setErrors] = useState([]);
	const [enabledItems, setEnabledItems] = useState(false);
	const [enabledTareas, setEnabledTareas] = useState(false);
	const [showItems, setShowItems] = useState([]);
	const [obligatoriosItem, setObligatoriosItem] = useState([]);
	const [showTareas, setShowTareas] = useState([]);
	const [obligatoriosTarea, setObligatoriosTarea] = useState([]);
	const [presupuestoIdActual, setPresupuestoIdActual] = useState(null);
	const [esRecotizacionParcial, setEsRecotizacionParcial] = useState(false);
	// VEC-3231: momento (inicial/adicional) real del borrador precargado, tomado del backend
	// (existeAprobado), para gris­ear por el permiso correcto sin depender solo de canDo('PRESUPUESTAR_ADIC').
	const [adicionalBorrador, setAdicionalBorrador] = useState(null);
	const obligatoriedadMutuaTareaItem = ConfigBusiness.get('tickets.presupuesto.obligatoriedadMutuaTareaItem') === 'true' ? true : false;
	const trabajaConManoDeObra = ConfigBusiness.get('tickets.trabajaConManoDeObra.habilitado') === 'true';
	// VEC-3231: feature flag por cliente. Si no está en 'true', no hay borrador ni carga parcial (legacy).
	const borradorHabilitado = ConfigBusiness.get('tickets.presupuesto.borrador.habilitado') === 'true';
	// VEC-3231: momento (inicial/adicional) autoritativo del próximo presupuesto, calculado por el backend
	// (existeAprobado) y pasado por el padre. Es la fuente única de verdad para el griseo por permiso y
	// para el nextState al enviar; null si el padre todavía no lo resolvió.
	const momentoAdicionalProp = (props.momentoAdicional === true || props.momentoAdicional === false) ? props.momentoAdicional : null;

	useEffect(() => {
	  	init();
  	}, []);

	// Inicializar tooltips cuando se agregan/modifican items o tareas
	useLayoutEffect(() => {
		// Destruir tooltips existentes primero
		$('[data-tooltip="tooltip"]').tooltip('dispose');
		
		// Pequeño delay para asegurar que el DOM esté actualizado
		const timer = setTimeout(() => {
			$('[data-tooltip="tooltip"]').tooltip();
		}, 100);
		
		return () => clearTimeout(timer);
	}, [presupuestoItems, presupuestoTareas]);

	/**
	 * VEC-3316 — trae el disponible de los ítems ya cargados y lo refresca cuando la lista cambia.
	 *
	 * Detrás del flag del módulo y de que el ticket tenga móvil: sin base no hay contra qué contar
	 * y el backend devolvería todo en null igual, así que ni se llama. Con Inventario apagado esta
	 * pantalla no hace una sola request de más.
	 *
	 * La dependencia es la lista de IDS y no el array de ítems: `presupuestoItems` se recrea en
	 * cada edición de cantidad o costo, y depender del array dispararía una request por tecla.
	 */
	const idsDeItems = presupuestoItems
		.map((item) => item.id_item)
		.filter((id) => id)
		.join(',');

	useEffect(() => {
		const habilitado = ConfigBusiness.get('inventarioItems.habilitado') === 'true';
		const movilId = props.ticket && props.ticket.movil ? props.ticket.movil.id : null;

		if (!habilitado || !movilId || !idsDeItems) {
			setStockPorItem({});
			return;
		}

		// F2.bis: con `presupuesto=` el backend devuelve el disponible SUMÁNDOLE lo que este mismo
		// presupuesto ya tiene reservado. Sin eso, editar un presupuesto que ya reservó todo lo suyo
		// ve el disponible en 0 —los envases están en RESERVADO, a nombre de él— y la pantalla le
		// avisa que falta stock de algo que ya tiene tomado.
		const delPresupuesto = presupuestoIdActual
			? '&presupuesto=' + encodeURIComponent(presupuestoIdActual)
			: '';

		Utils.getData('/items/stock-disponible?movil=' + encodeURIComponent(movilId) + '&items=' + idsDeItems + delPresupuesto)
			// Un fallo acá no puede romper la pantalla: el presupuesto se tiene que poder ver y
			// cargar igual. Sin mapa, el badge no se pinta y la validación no encuentra faltantes.
			.then((data) => setStockPorItem(data || {}))
			.catch(() => setStockPorItem({}));
	}, [idsDeItems, props.ticket, presupuestoIdActual]);

	/**
	 * El disponible de un ítem del presupuesto, o `null` si no se sabe.
	 *
	 * Único punto de lectura del mapa: la grilla y la validación del guardado tienen que responder
	 * lo mismo.
	 */
	const disponibleDe = (item) => {
		// VEC-3316: solo `.id_item`, sin caer a `.id` — en una línea persistida sin catálogo
		// (repuesto de descripción libre) `.id` es el id de `presupuesto_items`, no de `items`.
		const id = item ? item.id_item : null;

		if (!id) return null;

		const valor = stockPorItem[String(id)];

		return valor === undefined ? null : valor;
	};

	/**
	 * VEC-3316 — los repuestos del presupuesto que piden más de lo que hay en la base del móvil.
	 *
	 * Con el módulo apagado devuelve vacío, y con eso `handleSubmit()` queda EXACTAMENTE como antes
	 * de esta card. `disponibleDe()` en null es "no se puede saber" y no cuenta como faltante.
	 *
	 * ## SE AGRUPA POR ÍTEM, NO POR LÍNEA
	 *
	 * Espeja `ItemStockReservaService::faltantesDeLineas()`, que es quien decide de verdad: un mismo
	 * repuesto puede venir en dos líneas (dos tareas distintas), y comparándolas por separado dos
	 * líneas de 1 contra un único envase pasan las dos. Lo que se reserva es el total por ítem.
	 *
	 * La necesaria es la SUMA DE LOS REDONDEOS y no el redondeo de la suma: el compromiso reserva
	 * línea por línea con `ceil()` porque un envase es indivisible, y acá hay que pedir exactamente
	 * lo que el backend va a tomar. Si los dos criterios divergen, la pantalla deja guardar algo que
	 * el backend después rechaza, o al revés.
	 *
	 * El disponible ya viene con lo reservado por ESTE presupuesto sumado (F2.bis), así que acá no
	 * hay que descontar nada: el criterio vive en un solo lado.
	 */
	/**
	 * VEC-3529 — una línea YA APROBADA de una recotización parcial.
	 *
	 * Estaba definida dentro de `ejecutarGuardado()` y solo servía para armar el payload. Se subió acá
	 * porque el cálculo de faltantes de stock necesita el MISMO criterio: ver abajo.
	 */
	const esLineaAprobada = (linea) => (
		esRecotizacionParcial
		&& linea.estado_recotizacion !== 'nuevo'
		&& linea.estado_recotizacion !== 'rechazado'
	);

	/**
	 * VEC-3905 — manda al backend lo que el usuario resolvió en el modal de faltantes.
	 *
	 * UNA SOLA REQUEST PARA LAS DOS COSAS. El alta acepta `ediciones[]` además de `detalles[]`, y las
	 * aplica dentro de la MISMA transacción: o entra todo, o no entra nada.
	 *
	 * Antes esto eran N `PUT` en serie más un `POST`. Funcionaba, pero si una edición fallaba a mitad
	 * de camino quedaban aplicadas las anteriores y el usuario tenía que reconstruir qué había pasado
	 * a partir de un mensaje que nombraba un solo renglón. No había nada que lo revirtiera: son
	 * requests independientes y el navegador no tiene transacciones.
	 *
	 * El backend además valida que cada detalle editado sea DE ESTE TICKET, así que este camino no es
	 * más permisivo que el `PUT` suelto que usa la sección del ticket.
	 */
	const enviarSolicitudDeStock = (cantidades, ediciones) => {
		// Los renglones en 0 significan "de este no pido nada" y no viajan: el backend exige
		// cantidad >= 1 y los rechazaría a todos.
		const aCrear = (cantidades || []).filter((linea) => linea.cantidad > 0);

		return Utils.sendDataNoErrorMessage('/inventario/solicitudes', 'POST', {
			ticket: props.ticket.id,
			detalles: aCrear.map((linea) => ({ item: linea.item, cantidad: linea.cantidad })),
			ediciones: (ediciones || []).map((linea) => ({
				detalle: linea.detalleId,
				cantidad: linea.cantidad,
			})),
		});
	};

	/**
	 * VEC-3905 — los repuestos del presupuesto con la forma que espera el modal de solicitud.
	 *
	 * NO SE LE PUEDE PASAR `presupuestoItems` CRUDO, aunque hasta ahora se hacía: el modal lee
	 * `item.id`, `item.descripcion` y `item.stockDisponible`, y una línea de presupuesto no tiene esa
	 * forma. Mientras el modal no persistía nada la diferencia era invisible; con el POST no:
	 *
	 *   - `linea.id` es el id de `presupuesto_items`, NO el del catálogo. El del catálogo es
	 *     `id_item` — el mismo motivo por el que `disponibleDe()` no cae a `.id`. Mandarlo habría
	 *     creado solicitudes contra ítems equivocados, o 404 de un id que no existe en `items`.
	 *   - `stockDisponible` no vive en la línea sino en el mapa `stockPorItem`, así que la columna
	 *     Stock salía en '-' y la cantidad se precargaba con lo necesario entero en vez del faltante.
	 *
	 * AGREGA POR ÍTEM DEL CATÁLOGO, no por línea. Un presupuesto puede tener dos renglones del mismo
	 * repuesto y la solicitud es una sola por repuesto — es la unidad de la restricción de VEC-3905,
	 * y es también como `repuestosSinStock()` suma lo necesario.
	 */
	const repuestosParaSolicitud = () => {
		const porItem = {};

		presupuestoItems.forEach((linea) => {
			if (!linea.id_item) return;

			// Mismo criterio que `repuestosSinStock()`: lo ya aprobado en una parcial no se pide.
			if (esLineaAprobada(linea)) return;

			// Los envases son indivisibles: media unidad de un repuesto se pide como una.
			const cantidad = Math.ceil(Number(linea.cantidad || 0));

			if (cantidad <= 0) return;

			if (!porItem[linea.id_item]) {
				porItem[linea.id_item] = {
					id: linea.id_item,
					descripcion: linea.descripcion,
					cantidad: 0,
					stockDisponible: disponibleDe({ id_item: linea.id_item }),
				};
			}

			porItem[linea.id_item].cantidad += cantidad;
		});

		return Object.keys(porItem).map((id) => porItem[id]);
	};

	const repuestosSinStock = () => {
		if (ConfigBusiness.get('inventarioItems.habilitado') !== 'true') return [];

		const necesariaPorItem = {};

		presupuestoItems.forEach((item) => {
			if (!item.id_item) return;

			// VEC-3905 — LAS LÍNEAS YA APROBADAS DE UNA RECOTIZACIÓN PARCIAL NO PIDEN STOCK.
			//
			// Su stock ya está retenido por el presupuesto anterior: la parcial NO lo suelta (VEC-3316,
			// commits da3db9584 y 77b8e4be0). Y además ni siquiera viajan en el payload — `ejecutarGuardado`
			// las filtra con este mismo predicado —, así que el gate del backend nunca las mira.
			//
			// Sin esta línea, el front pedía una solicitud de stock por repuestos YA APROBADOS que el
			// backend no valida: un pedido al depósito por algo que el ticket ya tiene tomado.
			if (esLineaAprobada(item)) return;

			const cantidad = Math.ceil(Number(item.cantidad || 0));

			if (cantidad <= 0) return;

			necesariaPorItem[item.id_item] = (necesariaPorItem[item.id_item] || 0) + cantidad;
		});

		const conFaltante = Object.keys(necesariaPorItem).filter((idItem) => {
			const disponible = disponibleDe({ id_item: idItem });

			return disponible !== null && necesariaPorItem[idItem] > disponible;
		});

		// Sigue devolviendo LÍNEAS y no ítems: el único consumidor es `handleSubmit()`, que mira
		// `.length > 0` y arma el detalle del modal a partir de las líneas.
		return presupuestoItems.filter(
			(item) => item.id_item && conFaltante.includes(String(item.id_item))
		);
	};

	const init = () => {
		setImpuestos(0)
		setOtros(0)
		setAdjunto(null)
		setErrors([])
		let enabledItems = ConfigBusiness.get('tickets.presupuesto.items.habilitado') === 'true';
		let showItems = [];
		if(enabledItems){
			showItems = ConfigBusiness.get('tickets.presupuesto.items.show').split(',');
			setShowItems(showItems);
			let obligatorios = ConfigBusiness.get('tickets.presupuesto.items.obligatorios').split(',');
			obligatorios = obligatorios.filter((element) => showItems.includes(element));
			setObligatoriosItem(obligatorios);
		}
		setEnabledItems(enabledItems);

		let enabledTareas = ConfigBusiness.get('tickets.presupuesto.tareas.habilitado') === 'true'
		let showTareas = [];
		if(enabledTareas){
			showTareas = ConfigBusiness.get('tickets.presupuesto.tareas.show').split(',');
			setShowTareas(showTareas);
			let obligatorios = ConfigBusiness.get('tickets.presupuesto.tareas.obligatorios').split(',');
			obligatorios = obligatorios.filter((element) => showTareas.includes(element));
			setObligatoriosTarea(obligatorios);
		}
		setEnabledTareas(enabledTareas);

		if(props.ticket.presupuestoNombre && props.ticket.estado === 'RECOTIZAR'){
			// Recotización parcial: cargar ítems del presupuesto activo (Pendiente) para edición
			setLoading(true);
			Utils.getData('/ticket-presupuestos/ticket/' + props.ticket.id + '/items-activos')
				.then(function(data) {
					if (!data) { setLoading(false); return; }
					setPresupuestoIdActual(data.presupuestoId || null);
					if (data.impuestos) setImpuestos(data.impuestos);
					if (data.otros) setOtros(data.otros);
					var items = (data.items || []).map(function(pItem) {
						return {
							'cantidad': pItem.cantidad,
							'costo': pItem.precio, 'detalle': pItem.detalle || '',
							'descripcion': pItem.descripcion,
							'external_code': pItem.external_code,
							'id': pItem.id_item,
							'id_item': pItem.id_item,
							'servicio_id': pItem.servicio_id,
							'servicio_nombre': pItem.servicio ? pItem.servicio.nombre : null,
							'validacion_automatica': pItem.servicio ? pItem.servicio.validacion_automatica : null,
							'estado_recotizacion': pItem.estado_recotizacion || null,
							'comentario_rechazo': pItem.comentario_rechazo || null,
							'costo_fijo': pItem.item ? pItem.item.costo_fijo : null,
							'idPresupuestoItem': pItem.id,
							'idPresupuesto': pItem.id_presupuesto,
							'clasificacion': pItem.clasificacion && pItem.clasificacion.nombre ? pItem.clasificacion.nombre : '',
							// Se setean ambos campos con el mismo valor porque el endpoint de guardado lee
							// 'id_clasificacion' y el edit modal inicializa desde 'id_item_clasificacion'.
							// La API devuelve snake_case (toArray), no el camelCase de jsonSerialize (VEC-3258).
							// TODO VEC-3278: unificar ambos consumidores (guardado y edit modal) en un único campo y eliminar la duplicación.
							'id_clasificacion': pItem.id_item_clasificacion || (pItem.clasificacion && pItem.clasificacion.id) || null,
							'id_item_clasificacion': pItem.id_item_clasificacion || (pItem.clasificacion && pItem.clasificacion.id) || null,
							'mecanico_ids': pItem.mecanicos ? pItem.mecanicos.map(function(m) { return m.id; }) : [],
						};
					});
					var tareas = (data.tareas || []).map(function(pTarea) {
						return {
							'id_tarea': pTarea.id_tarea,
							'external_code': pTarea.external_code,
							'nombre': pTarea.descripcion,
							'cuenta_mayor': pTarea.servicio_external_code,
							'cuenta_mayor_descripcion': pTarea.servicio ? pTarea.servicio.nombre : null,
							'precio': pTarea.precio, 'detalle': pTarea.detalle || '',
							'cantidad': pTarea.cantidad || 1,
							'servicio_id': pTarea.servicio_id,
							'servicio_nombre': pTarea.servicio ? pTarea.servicio.nombre : null,
							'validacion_automatica': pTarea.servicio ? pTarea.servicio.validacion_automatica : null,
							'estado_recotizacion': pTarea.estado_recotizacion || null,
							'comentario_rechazo': pTarea.comentario_rechazo || null,
							'idPresupuestoTarea': pTarea.id,
							'idPresupuesto': pTarea.id_presupuesto,
							'mecanico_ids': pTarea.mecanicos ? pTarea.mecanicos.map(function(m) { return m.id; }) : [],
						};
					});
					var tieneRechazado = items.some(function(i) { return i.estado_recotizacion === 'rechazado'; })
						|| tareas.some(function(t) { return t.estado_recotizacion === 'rechazado'; });
					setEsRecotizacionParcial(tieneRechazado);
					setPresupuestoItems(items);
					setPresupuestoTareas(tareas);
					calculateTotal(items, tareas, data.impuestos || 0, data.otros || 0);
					setLoading(false);
				})
				.catch(function() { setLoading(false); });
		} else if(!props.ticket.presupuestoNombre){
			setLoading(true)
			Promise.all([
				((props.ticket.ticketTipo === 'PREVENTIVO' || props.ticket.ticketTipo === 'CORRECTIVO' || props.ticket.ticketTipo === 'VENCIMIENTO' || props.ticket.ticketTipo === 'PREDICTIVO') && props.ticket.servicio && enabledItems) ? Utils.getData(`/items/items-and-servicio-by-ticket/${props.ticket.id}`) : [],
				(props.ticket.ticketTipo === 'PREVENTIVO' || props.ticket.ticketTipo === 'CORRECTIVO' || props.ticket.ticketTipo === 'VENCIMIENTO' || props.ticket.ticketTipo === 'PREDICTIVO') ? Utils.getData(`/tareas/tareas-and-servicio-by-ticket/${props.ticket.id}`) : [],
				Utils.getData(`/ticket-presupuestos/ticket/${props.ticket.id}/items-activos`),
				Utils.getData(`/ticket-presupuestos/ticket/${props.ticket.id}/precargar-items`),
			])
			.then((data) => {
				// data[2] = items-activos (presupuesto Pendiente: recotización parcial con estados)
				// data[3] = precargar-items (último presupuesto Rechazado: recotización total)
				const itemsActivos  = (data[2] && data[2].items)  ? data[2].items  : [];
				const tareasActivas = (data[2] && data[2].tareas) ? data[2].tareas : [];
				const precargaItems  = (data[3] && data[3].items)  ? data[3].items  : [];
				const precargaTareas = (data[3] && data[3].tareas) ? data[3].tareas : [];

				// VEC-3398: /items-activos devuelve el último presupuesto SIN filtro de estado. Si ese
				// presupuesto ya está Aprobado/Auto-Aprobado no es una recotización en curso y NO debe
				// precargarse. Pasa cuando el ticket quedó con presupuesto_nombre vacío (p.ej. fue
				// rechazado y luego auto-aprobado) y cae en esta rama creyendo que no tiene presupuesto.
				const estadoActivos = (data[2] && data[2].estado) ? data[2].estado : null;
				const esPresupuestoCerrado = estadoActivos === 'Aprobado' || estadoActivos === 'Auto-Aprobado';

				// Prioridad 1: presupuesto activo (parcial) — preserva estado_recotizacion y comentario_rechazo
				if (!esPresupuestoCerrado && (itemsActivos.length > 0 || tareasActivas.length > 0)) {
					if (data[2].impuestos) setImpuestos(data[2].impuestos);
					if (data[2].otros) setOtros(data[2].otros);
					var items = itemsActivos.map(function(pItem) {
						return {
							'cantidad': pItem.cantidad,
							'costo': pItem.precio, 'detalle': pItem.detalle || '',
							'descripcion': pItem.descripcion,
							'external_code': pItem.external_code,
							'id': pItem.id_item,
							'id_item': pItem.id_item,
							'tipo': pItem.item ? pItem.item.tipo : null,
							'servicio_id': pItem.servicio_id,
							'servicio_nombre': pItem.servicio ? pItem.servicio.nombre : null,
							'validacion_automatica': pItem.servicio ? pItem.servicio.validacion_automatica : null,
							'estado_recotizacion': pItem.estado_recotizacion || null,
							'comentario_rechazo': pItem.comentario_rechazo || null,
							'costo_fijo': pItem.item ? pItem.item.costo_fijo : null,
							'clasificacion': pItem.clasificacion && pItem.clasificacion.nombre ? pItem.clasificacion.nombre : '',
							// Se setean ambos campos con el mismo valor porque el endpoint de guardado lee
							// 'id_clasificacion' y el edit modal inicializa desde 'id_item_clasificacion'.
							// La API devuelve snake_case (toArray), no el camelCase de jsonSerialize (VEC-3258).
							// TODO VEC-3278: unificar ambos consumidores (guardado y edit modal) en un único campo y eliminar la duplicación.
							'id_clasificacion': pItem.id_item_clasificacion || (pItem.clasificacion && pItem.clasificacion.id) || null,
							'id_item_clasificacion': pItem.id_item_clasificacion || (pItem.clasificacion && pItem.clasificacion.id) || null,
							'mecanico_ids': pItem.mecanicos ? pItem.mecanicos.map(function(m) { return m.id; }) : [],
						};
					});
					var tareas = tareasActivas.map(function(pTarea) {
						return {
							'id_tarea': pTarea.id_tarea,
							'external_code': pTarea.external_code,
							'nombre': pTarea.descripcion,
							'cuenta_mayor': pTarea.servicio_external_code,
							'cuenta_mayor_descripcion': pTarea.servicio ? pTarea.servicio.nombre : null,
							'precio': pTarea.precio, 'detalle': pTarea.detalle || '',
							'cantidad': pTarea.cantidad || 1,
							'servicio_id': pTarea.servicio_id,
							'servicio_nombre': pTarea.servicio ? pTarea.servicio.nombre : null,
							'validacion_automatica': pTarea.servicio ? pTarea.servicio.validacion_automatica : null,
							'estado_recotizacion': pTarea.estado_recotizacion || null,
							'comentario_rechazo': pTarea.comentario_rechazo || null,
							'mecanico_ids': pTarea.mecanicos ? pTarea.mecanicos.map(function(m) { return m.id; }) : [],
						};
					});
					var tieneRechazadoActivos = items.some(function(i) { return i.estado_recotizacion === 'rechazado'; })
						|| tareas.some(function(t) { return t.estado_recotizacion === 'rechazado'; });
					setEsRecotizacionParcial(tieneRechazadoActivos);
					if (trabajaConManoDeObra) {
						var itemsProducto = items.filter(function(i) { return !esManoDeObra(i.tipo); });
						var itemsMO = items.filter(function(i) { return esManoDeObra(i.tipo); });
						setPresupuestoItems(itemsProducto);
						setPresupuestoItemsManoDeObra(itemsMO);
						calculateTotal(itemsProducto, tareas, data[2].impuestos || 0, data[2].otros || 0, itemsMO);
					} else {
						setPresupuestoItems(items);
						calculateTotal(items, tareas, data[2].impuestos || 0, data[2].otros || 0);
					}
					setPresupuestoTareas(tareas);
					return;
				}

				// Prioridad 2: último presupuesto rechazado (total) — preserva precios del proveedor.
				// VEC-3398: igual que la Prioridad 1, si el último presupuesto ya está Aprobado/Auto-Aprobado
				// no hay recotización en curso y NO debe precargarse un rechazado histórico de un ciclo
				// anterior (pasa cuando el ticket cae en esta rama por presupuesto_nombre vacío). El flujo
				// legítimo de recotización total tiene el último presupuesto en Rechazado (no cerrado).
				if (!esPresupuestoCerrado && (precargaItems.length > 0 || precargaTareas.length > 0)) {
					var itemsPrecargados = precargaItems.map(function(pItem) {
						return {
							'cantidad': pItem.cantidad,
							'costo': pItem.precio, 'detalle': pItem.detalle || '',
							'descripcion': pItem.descripcion,
							'external_code': pItem.external_code,
							'id': pItem.id_item,
							'id_item': pItem.id_item,
							'tipo': pItem.item ? pItem.item.tipo : null,
							'servicio_id': pItem.servicio_id,
							'servicio_nombre': pItem.servicio ? pItem.servicio.nombre : null,
							'validacion_automatica': pItem.servicio ? pItem.servicio.validacion_automatica : null,
							'costo_fijo': pItem.item ? pItem.item.costo_fijo : null,
							'clasificacion': pItem.clasificacion && pItem.clasificacion.nombre ? pItem.clasificacion.nombre : '',
							// Se setean ambos campos con el mismo valor porque el endpoint de guardado lee
							// 'id_clasificacion' y el edit modal inicializa desde 'id_item_clasificacion'.
							// La API devuelve snake_case (toArray), no el camelCase de jsonSerialize (VEC-3258).
							// TODO VEC-3278: unificar ambos consumidores (guardado y edit modal) en un único campo y eliminar la duplicación.
							'id_clasificacion': pItem.id_item_clasificacion || (pItem.clasificacion && pItem.clasificacion.id) || null,
							'id_item_clasificacion': pItem.id_item_clasificacion || (pItem.clasificacion && pItem.clasificacion.id) || null,
							'mecanico_ids': pItem.mecanicos ? pItem.mecanicos.map(function(m) { return m.id; }) : [],
						};
					});
					var tareasPrecargadas = precargaTareas.map(function(pTarea) {
						return {
							'id_tarea': pTarea.id_tarea,
							'external_code': pTarea.external_code,
							'nombre': pTarea.descripcion,
							'cuenta_mayor': pTarea.servicio_external_code,
							'cuenta_mayor_descripcion': pTarea.servicio ? pTarea.servicio.nombre : null,
							'precio': pTarea.precio, 'detalle': pTarea.detalle || '',
							'cantidad': pTarea.cantidad || 1,
							'servicio_id': pTarea.servicio_id,
							'servicio_nombre': pTarea.servicio ? pTarea.servicio.nombre : null,
							'validacion_automatica': pTarea.servicio ? pTarea.servicio.validacion_automatica : null,
							'mecanico_ids': pTarea.mecanicos ? pTarea.mecanicos.map(function(m) { return m.id; }) : [],
						};
					});
					if (trabajaConManoDeObra) {
						var precargaProducto = itemsPrecargados.filter(function(i) { return !esManoDeObra(i.tipo); });
						var precargaMO = itemsPrecargados.filter(function(i) { return esManoDeObra(i.tipo); });
						setPresupuestoItems(precargaProducto);
						setPresupuestoItemsManoDeObra(precargaMO);
						calculateTotal(precargaProducto, tareasPrecargadas, 0, 0, precargaMO);
					} else {
						setPresupuestoItems(itemsPrecargados);
						calculateTotal(itemsPrecargados, tareasPrecargadas, 0, 0);
					}
					setPresupuestoTareas(tareasPrecargadas);
					return;
				}

				// Sin presupuesto anterior: cargar desde catálogo (primer presupuesto)
				var items = [];
				if(data[0]){
					data[0].forEach(element => {
						let cantidad = showTareas.includes('cantidad') ? (element.cantidad ? element.cantidad : "1") : "1"
						let costo = element.costo ? element.costo : "0";
						items.push({
							'cantidad': cantidad,
							'costo': costo,
							'cuenta_mayor': element.cuenta_mayor,
							'cuenta_mayor_descripcion': element.cuenta_mayor_descripcion,
							'descripcion': element.descripcion,
							'external_code': element.external_code,
							'id': element.id,
							'id_item': element.id_item,
							'marca': element.marca,
							'marcaNombre': element.marcaNombre,
							'numero_parte': element.numero_parte,
							'referencia': element.referencia,
							'servicio_id': element.servicio_id,
							'servicio_nombre': element.servicio_nombre,
							'servicio': { id: element.servicio_id, nombre: element.servicio_nombre },
							'validacion_automatica': element.validacion_automatica,
							'subcategoria': element.subcategoria,
							'tipo': element.tipo,
							'unidad': element.unidad,
							'costo_fijo': element.costo_fijo,
						});
					});
				}
				setPresupuestoItems(items);
				var tareas = [];
				if(data[1]){
					data[1].forEach(element => {
						let cantidad = showItems.includes('cantidad') ? (element.cantidad ? element.cantidad : "1") : "1"
						let precio = element.precio ? element.precio : "0";
						tareas.push({
							'id_tarea': element.id,
							'external_code': element.external_code,
							'nombre': element.nombre,
							'cuenta_mayor': element.servicio_external_code,
							'cuenta_mayor_descripcion': element.servicio_nombre,
							'precio': precio,
							'cantidad': cantidad,
							'servicio_id': element.servicio_id,
							'servicio_nombre': element.servicio_nombre,
							'validacion_automatica': element.validacion_automatica,
						});
					});
				}
				setPresupuestoTareas(tareas);
				if (trabajaConManoDeObra) {
					let itemsProducto = [];
					let itemsManoDeObra = [];
					items.forEach(function(item) {
						if (esManoDeObra(item.tipo)) {
							itemsManoDeObra.push(item);
						} else {
							itemsProducto.push(item);
						}
					});
					setPresupuestoItems(itemsProducto);
					setPresupuestoItemsManoDeObra(itemsManoDeObra);
					calculateTotal(itemsProducto, tareas, 0, 0, itemsManoDeObra);
				} else {
					setPresupuestoItems(items);
					calculateTotal(items, tareas, 0, 0, []);
				}
			})
			.catch((err) => {
				setLoading(false)
			}).finally(() => {
				setLoading(false)
			});
		} else if (borradorHabilitado) {
			// VEC-3231: ticket que YA tiene presupuesto y no está en recotización (ej. adicional sobre
			// aprobado). Si el último presupuesto es un BORRADOR, precargar sus ítems/tareas. Reusa
			// /items-activos (devuelve el último presupuesto, incluido el borrador). Las ramas de
			// recotización de arriba quedan intactas; esta rama solo cubre el hueco que antes no precargaba.
			setLoading(true);
			Utils.getData('/ticket-presupuestos/ticket/' + props.ticket.id + '/items-activos')
				.then(function(data) {
					if (data && data.estado === 'Borrador' && ((data.items && data.items.length > 0) || (data.tareas && data.tareas.length > 0))) {
						setPresupuestoIdActual(data.presupuestoId || null);
						setAdicionalBorrador(data.adicional ? true : false);
						if (data.impuestos) setImpuestos(data.impuestos);
						if (data.otros) setOtros(data.otros);
						var items = (data.items || []).map(function(pItem) {
							return {
								'cantidad': pItem.cantidad,
								'costo': pItem.precio, 'detalle': pItem.detalle || '',
								'descripcion': pItem.descripcion,
								'external_code': pItem.external_code,
								'id': pItem.id_item,
								'id_item': pItem.id_item,
								'tipo': pItem.item ? pItem.item.tipo : null,
								'servicio_id': pItem.servicio_id,
								'servicio_nombre': pItem.servicio ? pItem.servicio.nombre : null,
								'validacion_automatica': pItem.servicio ? pItem.servicio.validacion_automatica : null,
								'costo_fijo': pItem.item ? pItem.item.costo_fijo : null,
								'clasificacion': pItem.clasificacion && pItem.clasificacion.nombre ? pItem.clasificacion.nombre : '',
								'id_clasificacion': pItem.id_item_clasificacion || (pItem.clasificacion && pItem.clasificacion.id) || null,
								'id_item_clasificacion': pItem.id_item_clasificacion || (pItem.clasificacion && pItem.clasificacion.id) || null,
							};
						});
						var tareas = (data.tareas || []).map(function(pTarea) {
							return {
								'id_tarea': pTarea.id_tarea,
								'external_code': pTarea.external_code,
								'nombre': pTarea.descripcion,
								'cuenta_mayor': pTarea.servicio_external_code,
								'cuenta_mayor_descripcion': pTarea.servicio ? pTarea.servicio.nombre : null,
								'precio': pTarea.precio, 'detalle': pTarea.detalle || '',
								'cantidad': pTarea.cantidad || 1,
								'servicio_id': pTarea.servicio_id,
								'servicio_nombre': pTarea.servicio ? pTarea.servicio.nombre : null,
								'validacion_automatica': pTarea.servicio ? pTarea.servicio.validacion_automatica : null,
							};
						});
						if (trabajaConManoDeObra) {
							var itemsProducto = items.filter(function(i) { return !esManoDeObra(i.tipo); });
							var itemsMO = items.filter(function(i) { return esManoDeObra(i.tipo); });
							setPresupuestoItems(itemsProducto);
							setPresupuestoItemsManoDeObra(itemsMO);
							calculateTotal(itemsProducto, tareas, data.impuestos || 0, data.otros || 0, itemsMO);
						} else {
							setPresupuestoItems(items);
							calculateTotal(items, tareas, data.impuestos || 0, data.otros || 0);
						}
						setPresupuestoTareas(tareas);
					}
					setLoading(false);
				})
				.catch(function() { setLoading(false); });
		}
	};

	const calculateTotal = (items, tareas, impuestosActual, otrosActual, itemsManoDeObra) => {
		var itemsMdo = itemsManoDeObra ? itemsManoDeObra : [];

		let totalRepuestosNew = 0;
		items.forEach(element => {
			if(element.cantidad){
				if(element.costo){
					totalRepuestosNew += element.cantidad*element.costo
				}
			}
		});
		setTotalRepuestos(totalRepuestosNew);

		let totalItemsManoDeObra = 0;
		itemsMdo.forEach(element => {
			if(element.cantidad){
				if(element.costo){
					totalItemsManoDeObra += element.cantidad*element.costo
				}
			}
		});
		setTotalManoDeObraItems(totalItemsManoDeObra);

		let totalTareasNew = 0;
		tareas.forEach(element => {
			if(element.precio){
				totalTareasNew += element.cantidad*parseFloat(element.precio)
			}
		});
		setTotalTareas(totalTareasNew);
		let totalManoObraNew = totalItemsManoDeObra + totalTareasNew;
		setTotalManoObra(totalManoObraNew);

		let totalNew = 0;
		totalNew = totalRepuestosNew + totalManoObraNew + parseFloat(impuestosActual) + parseFloat(otrosActual);

		setTotal(totalNew)
  };

	const deleteServicioItem = (indexArray) => {
		let items = [];
		presupuestoItems.forEach((element, index) => {
			if (index!==indexArray) {
				items.push(element);
			}
		});
		calculateTotal(items, presupuestoTareas, impuestos, otros, presupuestoItemsManoDeObra);
		setPresupuestoItems(items);
  };

	const addPresupuestoRepuesto = (newServicioItem) => {
		let copy = JSON.parse(JSON.stringify(presupuestoItems));
		var entrada = Object.assign({}, newServicioItem);
		if (esRecotizacionParcial) {
			entrada.estado_recotizacion = 'nuevo';
		}
		copy.push(entrada);
		calculateTotal(copy, presupuestoTareas, impuestos, otros, presupuestoItemsManoDeObra);
		setPresupuestoItems(copy);
  };

	const addPresupuestoManoDeObraItem = (newItem) => {
		let copy = JSON.parse(JSON.stringify(presupuestoItemsManoDeObra));
		var entrada = Object.assign({}, newItem);
		if (esRecotizacionParcial) {
			entrada.estado_recotizacion = 'nuevo';
		}
		copy.push(entrada);
		calculateTotal(presupuestoItems, presupuestoTareas, impuestos, otros, copy);
		setPresupuestoItemsManoDeObra(copy);
	};

	const deletePresupuestoManoDeObraItem = (indexArray) => {
		let items = [];
		presupuestoItemsManoDeObra.forEach((element, index) => {
			if (index !== indexArray) {
				items.push(element);
			}
		});
		calculateTotal(presupuestoItems, presupuestoTareas, impuestos, otros, items);
		setPresupuestoItemsManoDeObra(items);
	};

	const updatePresupuestoManoDeObraItem = (data, index) => {
		if(data.cantidad !== undefined) presupuestoItemsManoDeObra[index].cantidad = data.cantidad;
		if(data.costo !== undefined) presupuestoItemsManoDeObra[index].costo = data.costo;
		if(data.detalle !== undefined) presupuestoItemsManoDeObra[index].detalle = data.detalle || '';
		if(data.mecanico_ids !== undefined) presupuestoItemsManoDeObra[index].mecanico_ids = data.mecanico_ids;
		if(data.clasificacion !== undefined) presupuestoItemsManoDeObra[index].clasificacion = data.clasificacion;
		if(data.id_clasificacion !== undefined) presupuestoItemsManoDeObra[index].id_clasificacion = data.id_clasificacion;
		calculateTotal(presupuestoItems, presupuestoTareas, impuestos, otros, presupuestoItemsManoDeObra);
	};

	const addPresupuestoTarea = (newPresupuestoTarea) => {
		let copy = JSON.parse(JSON.stringify(presupuestoTareas));
		var entrada = Object.assign({}, newPresupuestoTarea);
		if (esRecotizacionParcial) {
			entrada.estado_recotizacion = 'nuevo';
		}
		copy.push(entrada);
		calculateTotal(presupuestoItems, copy, impuestos, otros, presupuestoItemsManoDeObra);
		setPresupuestoTareas(copy);
  };

	const handleCancel = (newServicioItem) => {
		props.callbackClose();
		init();
  };

	const deletePresupuestoTareas = (indexArray) => {
		let tareas = [];
		presupuestoTareas.forEach((element, index) => {
			if (index!==indexArray) {
				tareas.push(element);
			}
		});
		calculateTotal(presupuestoItems, tareas, impuestos, otros, presupuestoItemsManoDeObra);
		setPresupuestoTareas(tareas);
  };

	const handleFormChangeImpuestos = (value) =>  {
		calculateTotal(presupuestoItems, presupuestoTareas, value ? value : 0, otros, presupuestoItemsManoDeObra);
		setImpuestos(value ? value : formatCost(0))
	}

	const handleFormChangeOtros = (value) =>  {
		calculateTotal(presupuestoItems, presupuestoTareas, impuestos, value ? value : 0, presupuestoItemsManoDeObra);
		setOtros(value ? value : formatCost(0))	
	}

	const validate = () => {
		if(ConfigBusiness.get('tickets.presupuesto.adjuntoObligatorio') === 'true' && !adjunto)
			return true;
		var totalItems = presupuestoItems.length + presupuestoItemsManoDeObra.length;
		if(obligatoriedadMutuaTareaItem){
			if(enabledItems){
				if (totalItems === 0) {
					return true;
				}
			}
			if(enabledTareas){
				if (presupuestoTareas.length === 0) {
					return true;
				}
			}
		}else{
			if(enabledItems && enabledTareas){
				if (!(totalItems > 0 || presupuestoTareas.length > 0)) {
					return true;
				}
			}
		}
		return false;
	}

	const detectarMezclaValidacionAutomatica = () => {
		// VEC-3738: con trabajaConManoDeObra los ítems de mano de obra viven en su propio state
		// (presupuestoItemsManoDeObra), separados de los de repuestos. Sin incluirlos acá el modal
		// no aparecía cuando la mezcla estaba entre un repuesto y una mano de obra, ni cuando estaba
		// entre dos líneas de mano de obra: sólo se detectaba dentro de los repuestos.
		// Mismo criterio que usa el payload en ejecutarGuardado.
		const itemsDeTodoTipo = trabajaConManoDeObra
			? presupuestoItems.concat(presupuestoItemsManoDeObra)
			: presupuestoItems;
		return tieneMezclaValidacionAutomatica([...itemsDeTodoTipo, ...presupuestoTareas]);
	}

	const ejecutarGuardado = (esBorrador, onExito) => {
		setLoading(true);
		let formDataCopy = JSON.parse(JSON.stringify(formData));
		formDataCopy.id = props.ticket.id
		formDataCopy.manoDeObra = totalManoObra
		formDataCopy.repuestos = totalRepuestos
		formDataCopy.impuestos = impuestos
		formDataCopy.otros = otros
		formDataCopy.adicional = false
		// VEC-3565: en recotización parcial las líneas APROBADAS no se envían. Son propiedad del backend,
		// que las reinserta desde el presupuesto parcial rechazado (Repository::reinsertarFilasAprobadas).
		// Antes se enviaban y el backend intentaba emparejarlas con las filas de DB por una key derivada del
		// contenido; esa key no distingue dos líneas del mismo ítem+servicio+clasificación con cantidades
		// distintas (caso normal en mano de obra), así que colapsaban y se perdían unidades, descuadrando el
		// header contra los ítems. Se siguen mostrando en pantalla (bloqueadas), solo no viajan en el payload.
		// El total del header lo recalcula el backend desde las filas persistidas, así que no hace falta que
		// totalManoObra/totalRepuestos las contemplen.
		const itemsAEnviar = trabajaConManoDeObra
			? presupuestoItems.concat(presupuestoItemsManoDeObra)
			: presupuestoItems
		formDataCopy.presupuestoItems = itemsAEnviar.filter(function (i) { return !esLineaAprobada(i) })
		formDataCopy.presupuestoTareas = presupuestoTareas.filter(function (t) { return !esLineaAprobada(t) })
		formDataCopy.adjunto = adjunto

		// En recotización parcial, incluir el ID del presupuesto existente para actualizar en lugar de crear
		if (presupuestoIdActual) {
			formDataCopy.idPresupuesto = presupuestoIdActual;
		}

		// VEC-3231: si se precargó un borrador, su 'adicional' (calculado por el backend con
		// existeAprobado) define el momento. Lo mandamos siempre — también al ENVIAR/promover — para
		// que el backend elija el nextState correcto (PRESUPUESTAR_ADIC vs PRESUPUESTAR) y transicione
		// el ticket. canDo('PRESUPUESTAR_ADIC') no es confiable acá (presupuestoIdActual ya está seteado).
		if (adicionalBorrador !== null) {
			formDataCopy.adicional = adicionalBorrador;
		} else if(!props.idPresupuesto && !presupuestoIdActual){
		    // VEC-3398: el prop autoritativo (existeAprobado) solo aplica con el flag de borrador ON.
		    // Con el flag OFF (flujo legacy) momentoAdicionalProp puede venir null/incorrecto y enviar
		    // adicional erróneo provoca 403; restauramos el fallback canDo('PRESUPUESTAR_ADIC').
		    if (borradorHabilitado && momentoAdicionalProp !== null) {
		        formDataCopy.adicional = momentoAdicionalProp;
		    } else {
		        formDataCopy.adicional = canDo('PRESUPUESTAR_ADIC') ? true : false;
		    }
		}

		// VEC-3231: el guardado de borrador (carga parcial) va a un endpoint dedicado que NO
		// transiciona el ticket; el guardado normal mantiene el endpoint de presupuestar.
		const url = esBorrador === true
			? `/ticket-presupuestos/ticket/${props.ticket.id}/borrador`
			: `/ticket-presupuestos/ticket/${props.ticket.id}`;

		// VEC-3203: el endpoint puede devolver el shape `{mensaje, context}` para errores 400.
		// Usamos `sendDataNoErrorMessage` (análogo a `getDataNoErrorMessage`) para evitar
		// que el flow legacy de `handleError` dispare un modal "Error" vacío antes de poder
		// traducir nosotros vía `translateBackendKey`.
		Utils.sendDataNoErrorMessage(url, 'POST', formDataCopy)
		.then(() => {
			// VEC-3905: aviso propio del llamador, antes de cerrar. Opcional — los llamadores que no
			// lo pasan se comportan igual que antes.
			if (typeof onExito === 'function') onExito();

			// VEC-3231: el modal detallado NO se remonta tras guardar (su key modalPresupuestoKey no se
			// incrementa en el save), así que init() no se re-ejecuta. Al guardar un BORRADOR recargamos
			// su contenido en vez de resetear, para que se vea al reabrir (el estado del componente persiste).
			if (esBorrador) {
				init();
			} else {
				resetPresupuesto();
				setLoading(false)
			}
			props.callbackSave();
			props.callbackClose();
		})
		.catch((err) => {
			setLoading(false);
			var status = err && err.response ? err.response.status : null;
			var data = err && err.response && err.response.data ? err.response.data : null;
			// VEC-3203 shape: { mensaje: <i18n-key>, context: {...} }
			if (status === 400 && data && data.mensaje && backendStrings[data.mensaje]) {
				var mensajeTraducido = Utils.translateBackendKey(data.mensaje, data.context, intl);
				setErrors([mensajeTraducido]);
				Swal.fire({
					title: intl.formatMessage({ id: 'common.error', defaultMessage: 'Error' }),
					text: mensajeTraducido,
					type: 'error',
					buttonsStyling: false,
					confirmButtonClass: 'btn btn-primary',
					confirmButtonText: intl.formatMessage({ id: 'Aceptar', defaultMessage: 'Aceptar' }),
				});
			} else if (data && data.detalle) {
				// Fallback al flow legacy basado en `detalle`.
				setErrors(Array.isArray(data.detalle) ? data.detalle : [data.detalle]);
			} else {
				// Fallback genérico para errores de red / 5xx (paridad con el modal que
				// dispararía Utils.sendData -> handleError si lo hubiéramos usado).
				Swal.fire({
					title: intl.formatMessage({ id: 'common.error', defaultMessage: 'Error' }),
					text: intl.formatMessage({ id: 'errors.default', defaultMessage: 'Ocurrió un error inesperado. Intente nuevamente.' }),
					type: 'error',
					buttonsStyling: false,
					confirmButtonClass: 'btn btn-primary',
					confirmButtonText: intl.formatMessage({ id: 'Aceptar', defaultMessage: 'Aceptar' }),
				});
			}
		});
	}

	// VEC-3231: al guardar un borrador, el backend NO valida obligatorios (para permitir el borrador
	// automático al crear el ticket con ítems heredados incompletos). Pero desde el modal validamos en
	// el front los obligatorios SOLO de los boxes que el usuario puede editar; el box en solo lectura
	// NO se valida (sus ítems pueden venir heredados sin completar y el usuario no puede arreglarlos).
	// Etiqueta legible para cada campo obligatorio (la clave coincide con la propiedad del ítem/tarea).
	const etiquetaCampoObligatorio = (campo) => {
		const etiquetas = {
			id: { id: 'Presupuesto.Id', defaultMessage: 'Id' },
			descripcion: { id: 'Presupuesto.Descripción', defaultMessage: 'Descripción' },
			nombre: { id: 'Presupuesto.Descripción', defaultMessage: 'Descripción' },
			clasificacion: { id: 'Presupuesto.Clasificación', defaultMessage: 'Clasificación' },
			cantidad: { id: 'Presupuesto.Cantidad', defaultMessage: 'Cantidad' },
			precio: { id: 'Presupuesto.Precio', defaultMessage: 'Precio' },
			marca: { id: 'Presupuesto.Marca', defaultMessage: 'Marca' },
			servicio: { id: 'Presupuesto.Servicio', defaultMessage: 'Servicio' },
			detalle: { id: 'Presupuesto.Detalle', defaultMessage: 'Detalle' },
			cuenta_mayor: { id: 'Presupuesto.Cuenta_Mayor', defaultMessage: 'Cuenta Mayor' },
			descrip_cuenta_mayor: { id: 'Presupuesto.descrip._Cuenta_Mayor', defaultMessage: 'Descrip. Cuenta Mayor' },
		};
		return etiquetas[campo] ? intl.formatMessage(etiquetas[campo]) : campo;
	};

	// Resuelve el valor de un campo obligatorio tolerando las distintas representaciones de un ítem/tarea:
	// los ítems agregados a mano usan las claves del form (servicio objeto, costo, marca), mientras que los
	// PRECARGADOS (heredados / borrador) llegan mapeados con otras claves (servicio_id/servicio_nombre,
	// costo, sin marca). Sin esta normalización, validar `item['servicio']` o `item['marca']` sobre un ítem
	// precargado daría undefined => siempre "faltante" => bloquearía guardar un borrador válido. La emptiness
	// se evalúa con esValorObligatorioFaltante (VEC-3436): 0 es válido solo para costo/precio, no para cantidad.
	const valorCampoObligatorio = (item, campo) => {
		switch (campo) {
			case 'servicio':      return item.servicio || item.servicio_id || item.servicio_nombre;
			case 'marca':         return item.marca || item.marca_id;
			case 'clasificacion': return item.clasificacion || item.id_clasificacion || item.id_item_clasificacion;
			case 'mecanico':      return (item.mecanico_ids && item.mecanico_ids.length) ? item.mecanico_ids : item.mecanico;
			// Los repuestos usan 'costo'; las tareas usan 'precio'. Soporta config que pida 'precio' o 'costo'.
			case 'precio':
			case 'costo':         return (item.costo !== undefined && item.costo !== null && item.costo !== '') ? item.costo : item.precio;
			default:              return item[campo];
		}
	};

	// VEC-3436: 0 (cero) es un valor válido SOLO para costo/precio; para el resto de los campos (cantidad, etc.)
	// el 0 sigue siendo faltante. Sin esto, `!valor` marcaba el 0 de costo como incompleto y bloqueaba el borrador.
	const esValorObligatorioFaltante = (campo, valor) => {
		if (campo === 'costo' || campo === 'precio') {
			return valor === undefined || valor === null || valor === '';
		}
		return !valor;
	};

	// Devuelve las etiquetas (sin duplicados) de los campos obligatorios incompletos en los boxes editables.
	const obtenerCamposObligatoriosFaltantes = () => {
		const faltantes = [];
		const acumularFaltantes = (lista, obligatorios) => {
			(lista || []).forEach(item => {
				(obligatorios || []).forEach(campo => {
					if (esValorObligatorioFaltante(campo, valorCampoObligatorio(item, campo)) && faltantes.indexOf(campo) === -1) {
						faltantes.push(campo);
					}
				});
			});
		};
		if (puedeRepuestos) acumularFaltantes(presupuestoItems, obligatoriosItem);
		if (trabajaConManoDeObra && puedeManoDeObra) acumularFaltantes(presupuestoItemsManoDeObra, obligatoriosItem);
		if (!trabajaConManoDeObra && puedeManoDeObra) acumularFaltantes(presupuestoTareas, obligatoriosTarea);
		return faltantes.map(etiquetaCampoObligatorio);
	};

	// Guardar como borrador (carga parcial). No requiere la advertencia de mezcla de validación
	// automática porque no presupuesta (no transiciona el ticket).
	const handleGuardarBorrador = () => {
		const camposFaltantes = obtenerCamposObligatoriosFaltantes();
		if (camposFaltantes.length > 0) {
			Swal.fire({
				title: intl.formatMessage({ id: 'ticketPresupuestoDetallado.borrador.camposObligatorios', defaultMessage: 'Campos obligatorios' }),
				text: intl.formatMessage(
					{ id: 'ticketPresupuestoDetallado.borrador.completarObligatorios', defaultMessage: 'Completá los siguientes campos obligatorios antes de guardar el borrador: {campos}.' },
					{ campos: camposFaltantes.join(', ') }
				),
				type: 'warning',
				buttonsStyling: false,
				confirmButtonClass: 'btn btn-primary',
				confirmButtonText: intl.formatMessage({ id: 'Aceptar', defaultMessage: 'Aceptar' }),
			});
			return;
		}
		ejecutarGuardado(true);
	};

	const handleSubmit = () =>  {
		// VEC-2591: el botón Guardar valida los mismos obligatorios que el borrador (paridad). Así una
		// cantidad en 0 (obligatoria) tampoco se puede guardar acá; 0.1 sí pasa (0 solo es válido en costo/precio).
		const camposFaltantes = obtenerCamposObligatoriosFaltantes();
		if (camposFaltantes.length > 0) {
			Swal.fire({
				title: intl.formatMessage({ id: 'ticketPresupuestoDetallado.borrador.camposObligatorios', defaultMessage: 'Campos obligatorios' }),
				text: intl.formatMessage(
					{ id: 'ticketPresupuestoDetallado.guardar.completarObligatorios', defaultMessage: 'Completá los siguientes campos obligatorios antes de guardar: {campos}.' },
					{ campos: camposFaltantes.join(', ') }
				),
				type: 'warning',
				buttonsStyling: false,
				confirmButtonClass: 'btn btn-primary',
				confirmButtonText: intl.formatMessage({ id: 'Aceptar', defaultMessage: 'Aceptar' }),
			});
			return;
		}
		// VEC-3316 — sin stock no se completa la carga.
		//
		// A diferencia del ALTA del correctivo, donde la solicitud es opcional, acá es BLOQUEANTE:
		// presupuestar es lo que compromete el stock (los envases pasan a RESERVADO, y a UTILIZADO
		// si el presupuesto se auto-aprueba), así que no se puede presupuestar lo que no hay.
		//
		// Por eso tampoco se muestra el modal de pregunta: va directo al formulario de cantidades.
		//
		// ## EL MODAL GUARDA COMO BORRADOR
		//
		// El gate del backend (`assertStockSuficienteParaPresupuestar`) sigue rechazando el guardado
		// NORMAL sin stock, y es lo que queremos: un presupuesto que no puede reservar no avanza de
		// estado. Lo que cambió es que el trabajo cargado ya no se pierde — el modal lo guarda por el
		// endpoint de BORRADOR, que no valida ni compromete stock.
		//
		// El usuario lo promueve después, cuando el depósito le entregó lo que pidió: ahí la promoción
		// entra por `create()`, que vuelve a pasar por el gate. O sea que la regla "solo se presupuesta
		// con el stock completo" la sigue sosteniendo el backend, sin estados ni transiciones nuevas.
		//
		// VEC-3905 — ACÁ LA SOLICITUD SÍ SE PERSISTE. El modal postea contra
		// `POST /api/inventario/solicitudes` y espera la respuesta antes de cerrarse, así que el
		// usuario se entera de si el pedido salió o falló (pedido de Ivan, 11/09). Acá el ticket YA
		// EXISTE, que es lo que lo hace posible desde el `preConfirm`; en el alta del correctivo no,
		// y por eso allá el POST va después de crear el ticket.
		// SE ABRE CADA VEZ QUE FALTE STOCK, sin flag que lo saltee.
		//
		// Antes un `solicitudStockResuelta` hacía que el segundo Guardar se saltara el modal y fuera
		// directo al gate: el usuario veía "faltan repuestos" y no podía ver ni editar la solicitud que
		// acababa de hacer. Tenía sentido cuando el modal no persistía nada — reabrirlo habría sido un
		// callejón—, pero ahora el modal ES el lugar donde se revisa y se ajusta lo pedido, así que
		// saltearlo es esconder justo lo que el usuario necesita.
		//
		// No hay bucle: al confirmar, el presupuesto se guarda como borrador y el modal del presupuesto
		// se cierra. Y mientras falte stock, el único camino honesto hacia adelante es conseguirlo.
		if (repuestosSinStock().length > 0) {
			// Qué repuestos de este ticket ya tienen una solicitud abierta, para marcarlos en el modal
			// en vez de dejar que el alta choque contra el 400 de unicidad.
			//
			// Un fallo NO puede frenar el flujo: es información accesoria. Sin el mapa el modal se abre
			// igual, sin marcas, y si el usuario pide algo repetido el backend lo rechaza con su mensaje.
			//
			// `getDataNoErrorMessage` y no `getData`: este último llama a `handleError`, que abre el modal
			// de error legacy ANTES de rechazar — el usuario vería un "Error" encima del formulario por una
			// consulta accesoria que el `catch` de abajo ya absorbe.
			Utils.getDataNoErrorMessage('/inventario/solicitudes?ticket=' + encodeURIComponent(props.ticket.id))
				.then((data) => solicitudesAbiertasPorItem(data && data.solicitudes))
				.catch(() => ({}))
				.then((yaSolicitados) => {
					pedirCantidadesSolicitud(
						intl,
						repuestosParaSolicitud(),
						// El botón dice las DOS cosas desde que el presupuesto se guarda: con el texto
						// viejo ("Enviar solicitud de stock") el usuario no se enteraba de que su
						// presupuesto quedaba guardado, y lo volvía a cargar.
						borradorHabilitado
							? intl.formatMessage({
								id: 'ticketPresupuestoDetallado.solicitudStock.enviar_y_guardar',
								defaultMessage: ' Guardar borrador y enviar solicitud',
							})
							: intl.formatMessage({
								id: 'ticketPresupuestoDetallado.solicitudStock.enviar',
								defaultMessage: ' Enviar solicitud de stock',
							}),
						{
							yaSolicitados: yaSolicitados,
							// `sendDataNoErrorMessage` y no `sendData`: el handler genérico abriría su propio
							// modal de error ENCIMA de este, y el mensaje tiene que salir adentro del
							// formulario para no perder las cantidades cargadas.
							enviar: (cantidades, ediciones) => enviarSolicitudDeStock(cantidades, ediciones),
						}
					).then((cantidades) => {
						const accion = accionTrasSolicitudStock(cantidades, borradorHabilitado);

						// Cancelar deja el formulario como está: es la salida para corregir las cantidades
						// o sacar el repuesto.
						if (accion === CANCELADO) return;

						// EL PRESUPUESTO SE GUARDA COMO BORRADOR, no se pierde.
						//
						// El gate del backend (`assertStockSuficienteParaPresupuestar`) sigue rechazando el
						// guardado NORMAL sin stock, y está bien: es lo que garantiza que el presupuesto no
						// avance de estado hasta que el stock esté completo. Pero el borrador entra por otro
						// endpoint, que no valida ni compromete stock, así que el trabajo cargado se conserva
						// y el usuario lo promueve cuando el depósito le entregue lo que pidió.
						//
						// EL ORDEN ES SOLICITUD -> BORRADOR, y no al revés. Si el guardado del borrador
						// fallara, `ejecutarGuardado` deja el formulario abierto con todo cargado y muestra su
						// propio error; al reintentar, la solicitud ya enviada NO se duplica, porque el modal
						// marca los repuestos que ya tienen una pendiente (VEC-3905). Al revés no hay red:
						// habría que refactorizar el guardado compartido para propagar su error hasta acá.
						//
						// SIN EL FLAG DE BORRADOR no hay dónde caer: queda el comportamiento de antes — la
						// solicitud se envía y el presupuesto no se guarda.
						if (accion !== GUARDAR_BORRADOR) {
							Swal.fire({
								title: intl.formatMessage({
									id: 'ticketPresupuestoDetallado.solicitudStock.enviada_titulo',
									defaultMessage: 'Solicitud de stock enviada',
								}),
								text: intl.formatMessage({
									id: 'ticketPresupuestoDetallado.solicitudStock.enviada_texto',
									defaultMessage: 'El depósito ya tiene el pedido. Podés seguirlo desde las solicitudes del ticket.',
								}),
								// `type` y no `icon`: sweetalert2 está en la 7.33 y `icon` recién existe desde la v9.
								type: 'success',
							});

							return;
						}

						ejecutarGuardado(true, () => {
							Swal.fire({
								title: intl.formatMessage({
									id: 'ticketPresupuestoDetallado.solicitudStock.borrador_titulo',
									defaultMessage: 'Solicitud enviada y presupuesto guardado como borrador',
								}),
								text: intl.formatMessage({
									id: 'ticketPresupuestoDetallado.solicitudStock.borrador_texto',
									defaultMessage: 'El depósito ya tiene el pedido. Cuando haya stock de todos los repuestos vas a poder presupuestarlo.',
								}),
								type: 'success',
							});
						});
					});
				});

			return;
		}

		// Detectar si hay mezcla de servicios con y sin validación automática
		if (ConfigBusiness.get('tickets.presupuesto.servicios.autoAprobacion') === 'true' && detectarMezclaValidacionAutomatica()) {
			const mensajeParte1 = intl.formatMessage({ 
				id: 'Mezcla_validacion_automatica_v2_parte1', 
				defaultMessage: 'Este presupuesto contiene items/tareas con' 
			});
			const mensajeParte2 = intl.formatMessage({ 
				id: 'Mezcla_validacion_automatica_v2_parte2', 
				defaultMessage: 'servicios de validación automática' 
			});
			const mensajeParte3 = intl.formatMessage({ 
				id: 'Mezcla_validacion_automatica_v2_parte3', 
				defaultMessage: 'y otros de' 
			});
			const mensajeParte4 = intl.formatMessage({ 
				id: 'Mezcla_validacion_automatica_v2_parte4', 
				defaultMessage: 'auto-aprobación por monto máximo' 
			});
			const mensajeParte5 = intl.formatMessage({ 
				id: 'Mezcla_validacion_automatica_v2_parte5', 
				defaultMessage: 'Las líneas con validación automática se excluyen del total' 
			});
			const mensajeParte6 = intl.formatMessage({ 
				id: 'Mezcla_validacion_automatica_v2_parte6', 
				defaultMessage: 'y el resto se evalúa contra el monto máximo, por lo que el presupuesto podría requerir aprobación manual.' 
			});
			const mensajeParte7 = intl.formatMessage({ 
				id: 'Mezcla_validacion_automatica_v2_parte7', 
				defaultMessage: '¿Desea continuar?' 
			});

			const htmlMensaje = `${mensajeParte1} <b>${mensajeParte2}</b> ${mensajeParte3} <b>${mensajeParte4}</b>.<br/><br/><strong>${mensajeParte5}</strong> ${mensajeParte6}<br/><br/>${mensajeParte7}`;

			Swal.fire({
				title: intl.formatMessage({ id: 'Atencion', defaultMessage: 'Atención' }),
				html: htmlMensaje,
				type: 'warning', // correcto para sweetalert2 v7
				showCancelButton: true,
				confirmButtonColor: '#0ABFBC',
				cancelButtonColor: '#FF3145',
				confirmButtonText: intl.formatMessage({ id: 'Si_continuar', defaultMessage: 'Sí, continuar' }),
				cancelButtonText: intl.formatMessage({ id: 'Cancelar', defaultMessage: 'Cancelar' })
			  }).then((result) => {
				if (result.value) {
				  	ejecutarGuardado();
				}
			  });
			  
		} else {
			// No hay mezcla, proceder normalmente
			ejecutarGuardado();
		}
	}

	const resetPresupuesto = (data, index) => {
		setFormData({ ...FORM_DATA_INIT })
		setTotalRepuestos(0)
		setPresupuestoItems([]);
		setPresupuestoTareas([]);
		setPresupuestoItemsManoDeObra([]);
		setTotalManoDeObraItems(0);
		setTotalTareas(0);
		calculateTotal([],[], 0, 0)
		setImpuestos(0);
		setOtros(0);
		setAdjunto(0);
	}

	const canDo = (action) => {
		return props.actions.indexOf(action) >= 0;
	}

	const updateServicioItem = (data, index) => {
		presupuestoItems[index].cantidad = data.cantidad
		presupuestoItems[index].costo = data.costo
		presupuestoItems[index].detalle = data.detalle || ''
		if (data.clasificacion !== undefined) presupuestoItems[index].clasificacion = data.clasificacion;
		if (data.id_clasificacion !== undefined) presupuestoItems[index].id_clasificacion = data.id_clasificacion;
		calculateTotal(presupuestoItems, presupuestoTareas, impuestos, otros, presupuestoItemsManoDeObra);
	}

	const updatePresupuestoTarea = (data, index) => {
		if(data.cantidad !== undefined) presupuestoTareas[index].cantidad = data.cantidad;
		if(data.costo !== undefined) presupuestoTareas[index].precio = data.costo;
		if(data.detalle !== undefined) presupuestoTareas[index].detalle = data.detalle || '';
		if(data.mecanico_ids !== undefined) presupuestoTareas[index].mecanico_ids = data.mecanico_ids;
		if(data.clasificacion !== undefined) presupuestoTareas[index].clasificacion = data.clasificacion;
		if(data.id_clasificacion !== undefined) presupuestoTareas[index].id_clasificacion = data.id_clasificacion;
		calculateTotal(presupuestoItems, presupuestoTareas, impuestos, otros);
	}
	
	// VEC-3231: con la config de borrador habilitada, los permisos de precarga por tipo+momento son los
	// que definen qué puede cargar el usuario; NO hay fallback al permiso de envío. Si no tiene ninguno
	// de los 4 permisos para el momento, ambos boxes quedan en solo lectura aunque pueda enviar a
	// presupuestar. Con la config deshabilitada vale el comportamiento legacy (edición completa con
	// permiso de envío). El backend aplica la misma lógica — deben coincidir.
	// VEC-3231: el momento (inicial/adicional) lo define existeAprobado, que el backend expone en
	// /items-activos.adicional y el padre nos pasa como prop (momentoAdicional). Es la MISMA fuente que
	// usa el backend en guardarBorrador, así el griseo por tipo coincide con el enforcement del server.
	// NO se usa canDo('PRESUPUESTAR_ADIC'): depende de las transiciones de workflow disponibles (y de los
	// permisos de ENVÍO), no del momento real — un usuario con permiso de carga adicional pero sin la
	// transición de envío caía erróneamente en el momento inicial. Orden: borrador precargado > prop > canDo.
	const adicionalActual = adicionalBorrador !== null
		? adicionalBorrador
		: (momentoAdicionalProp !== null ? momentoAdicionalProp : canDo('PRESUPUESTAR_ADIC'));
	const puedeEnviar = Security.hasPermission('TICKETS_CARGAR_PRESUPUESTO') || Security.hasPermission('TICKETS_MODIFICAR_PRESUPUESTADOS');
	const permisoRepuestos = permisosCargaPorMomento(adicionalActual).repuestos;
	const permisoManoDeObra = permisosCargaPorMomento(adicionalActual).manoDeObra;
	const tieneCargaMomento = borradorHabilitado && (Security.hasPermission(permisoRepuestos) || Security.hasPermission(permisoManoDeObra));
	const puedeRepuestos = borradorHabilitado ? Security.hasPermission(permisoRepuestos) : puedeEnviar;
	const puedeManoDeObra = borradorHabilitado ? Security.hasPermission(permisoManoDeObra) : puedeEnviar;

  return (
	<React.Fragment>
	  	{redirectTo && <Redirect push to={redirectTo} />}
	  	{loading && <Loading />}
			<div>
				<div className="alert alert-danger" role="alert" hidden={errors.length===0}>
					{errors.map((e, i) => <li key={i}>{backendStrings[e] ? <FormattedMessage {...backendStrings[e]}/> : e}</li>)}
				</div>


				{enabledItems ? 
					<div className="card pull-up">
						<div className="card-content">
							<div className="card-body">
								<h4 className="form-section">
									<i className="la la-file-text"></i><FormattedMessage id="Repuesto" defaultMessage="Repuesto"/>
								</h4>
								<div className="row">
									<div className="col-md-12">
										<PresupuestoDetalladoItem
											ticket={props.ticket}
											tipoItem={trabajaConManoDeObra ? ITEM_TIPO_PRODUCTO : undefined}
											presupuestoItems={presupuestoItems}
											stockPorItem={stockPorItem}
											deleteItem={deleteServicioItem}
											addItemServicio={addPresupuestoRepuesto}
											totalRepuestos={totalRepuestos}
											updateServicioItem={updateServicioItem}
											showItems={showItems.filter(function(f) { return f !== 'mecanico'; })}
											obligatorios={obligatoriosItem}
											esRecotizacionParcial={esRecotizacionParcial}
											soloLectura={!puedeRepuestos}
										>
										</PresupuestoDetalladoItem>
									</div>
								</div>
							</div>
						</div>
					</div>
					: null
				}
				{trabajaConManoDeObra && enabledItems ?
					<div className="card pull-up">
						<div className="card-content">
							<div className="card-body">
								<h4 className="form-section">
									<i className="la la-file-text"></i>
									<FormattedMessage id="Mano_de_Obra" defaultMessage="Mano de Obra"/>
								</h4>
								<div className="row">
									<div className="col-md-12">
										<PresupuestoDetalladoItem
											ticket={props.ticket}
											tipoItem={ITEM_TIPO_MANO_DE_OBRA}
											presupuestoItems={presupuestoItemsManoDeObra}
											deleteItem={deletePresupuestoManoDeObraItem}
											addItemServicio={addPresupuestoManoDeObraItem}
											totalRepuestos={totalManoDeObraItems}
											updateServicioItem={updatePresupuestoManoDeObraItem}
											showItems={showItems}
											obligatorios={obligatoriosItem}
											esRecotizacionParcial={esRecotizacionParcial}
											soloLectura={!puedeManoDeObra}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					: null
				}
				{!trabajaConManoDeObra && enabledTareas ?
					<div className="card pull-up">
						<div className="card-content">
							<div className="card-body">
								<h4 className="form-section">
									<i className="la la-file-text"></i><FormattedMessage id={trabajaConManoDeObra ? "Tareas" : "Mano_de_Obra"} defaultMessage={trabajaConManoDeObra ? "Tareas" : "Mano de Obra"}/>
								</h4>
								<div className="row">
									<div className="col-md-12">
										<PresupuestoDetalladoTarea
											ticket={props.ticket}
											presupuestoTareas={presupuestoTareas}
											deleteTarea={deletePresupuestoTareas}
											addTarea={addPresupuestoTarea}
											totalManoObra={trabajaConManoDeObra ? totalTareas : totalManoObra}
											labelTotal={trabajaConManoDeObra ? "Total Tareas" : undefined}
											updatePresupuestoTarea={updatePresupuestoTarea}
											showTareas={showTareas}
											obligatorios={obligatoriosTarea}
											esRecotizacionParcial={esRecotizacionParcial}
											soloLectura={!puedeManoDeObra}
										>
										</PresupuestoDetalladoTarea>
									</div>
								</div>
							</div>
						</div>
					</div>
					: null
				}
				<div className="card pull-up">
					<div className="card-content">
						<div className="card-body">
							<h4 className="form-section">
								<i className="la la-file-text"></i>
							</h4>
							<div className="row">
								<div className="col-md-6">
									<div className="form-group row">
										<label className="col-md-12 label-control col-form-label text-left">
											<FormattedMessage id="Adjunto" defaultMessage="Adjunto"/>
											{ ConfigBusiness.get('tickets.presupuesto.adjuntoObligatorio') === 'true' ? requiredSymbol : ''}:
										</label>
										<div className="col-md-3"></div>
										<Dropzone actions={props.actions} setAdjunto={setAdjunto} guardarLog={false}></Dropzone>
									</div>
								</div>
								<div className="col-md-6">
									{ConfigBusiness.get('tickets.presupuesto.impuestos.habilitado')==="true" ?
										<div className="col-md-12">
											<div className="row p-1" style={{justifyContent: "right"}}>
												<label className="col-md-6 label-control col-form-label" htmlFor="impuestos">
													<FormattedMessage id="Impuestos" defaultMessage="Impuestos"/> :
												</label>
												<div className="col-md-6">
													<div>
														<input
															type="number"
															className="form-control text-right pr-1"
															id="impuestos"
															name="impuestos"
															value={formatCost(impuestos)}
															onChange={(e) => handleFormChangeImpuestos(e.target.value)}
														/>
													</div>
												</div>
											</div>
										</div>
									: null}
									{ConfigBusiness.get('tickets.presupuesto.otros.habilitado')==="true" ?
										<div className="col-md-12">
											<div className="row p-1" style={{justifyContent: "right"}}>
												<label className="col-md-6 label-control col-form-label" htmlFor="otros">
													<FormattedMessage id="Otros" defaultMessage="Otros"/> :
												</label>
												<div className="col-md-6">
													<div>
														<input
															type="number"
															className="form-control text-right pr-1"
															id="otros"
															name="otros"
															value={formatCost(otros)}
															onChange={(e) => handleFormChangeOtros(e.target.value)}
														/>
													</div>
												</div>
											</div>
										</div>
									: null}
									<div className="col-md-12">
										<div className="row p-1" style={{justifyContent: "right"}}>
											<label className="col-md-6 label-control col-form-label" htmlFor="total">
												<b><FormattedMessage id="Total" defaultMessage="Total"/></b> :
											</label>
											<div className="col-md-6">
												<div>
													<input disabled 
														type="number"
														className="form-control text-right pr-1"
														id="total"
														name="total"
														value={formatCost(total)}
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="card pull-up">
					<div className="card-content">
						<div className="card-body">
						<div className="text-cd text-right">
							{tieneCargaMomento ? (
								<button
									type="button"
									className="btn btn-secondary mr-1"
									onClick={handleGuardarBorrador}
									disabled={validate() || loading}
								>
									<i className="fa fa-save"></i> <FormattedMessage id="ticketPresupuestoDetallado.guardarBorrador" defaultMessage="Guardar borrador"/>
								</button>
							) : ''}
							{(Security.hasPermission('TICKETS_CARGAR_PRESUPUESTO') || Security.hasPermission('TICKETS_MODIFICAR_PRESUPUESTADOS')) ? (
							<button
								type="submit"
								className="btn btn-primary mr-1"
								onClick={handleSubmit}
								disabled={validate() || loading}
							>
								{loading ? (
									<>
										<i className="fa fa-spinner fa-spin"></i> <FormattedMessage id="Guardando" defaultMessage="Guardando..."/>
									</>
								) : (
									<>
										<i className="fa fa-check-circle"></i> <FormattedMessage id="Guardar" defaultMessage="Guardar"/>
									</>
								)}
							</button>
							) : ''}
							<button type="button" className="btn btn-danger" onClick={handleCancel} disabled={loading}>
								<i className="fa fa-times-circle"></i> <FormattedMessage id="Cancelar" defaultMessage="Cancelar"/>
							</button>
						</div>
						</div>
					</div>
				</div>
			</div>
	</React.Fragment>
  );
};

export default injectIntl(TicketPresupuestoDetallado);
